import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackOpenedEditPersonModal.meta';

export type UseTrackOpenedEditPersonModalParams = {
  person_id: string;
  location:
    | 'image-preview'
    | 'people-tab'
    | 'named-people-page'
    | 'unnamed-people-page'
    | 'person-page-header'
    | 'person-page-menu'
    | 'people-settings';
};

export const useTrackOpenedEditPersonModal = () => {
  const { track } = useAnalyticsUtilities();

  const trackOpenedEditPersonModal = useCallback(
    (params: UseTrackOpenedEditPersonModalParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackOpenedEditPersonModal };
};
